import {
	Component, Input, SimpleChanges, ViewChild
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ComponentBase, Changeable } from "common";
import { ViewerDeviceGroupDto } from 'UvExplorerServer.Dtos.TS/Viewer';
import { SelectItem } from 'primeng/api';
import { LayoutSettingsComponent } from 'topomap';


@Component({
    selector: 'map-settings',
	templateUrl: './map-settings.component.html',
	styleUrls: ['./map-settings.component.scss'],
//	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapSettingsComponent extends ComponentBase implements Changeable {

	@Input()
	public target: ViewerDeviceGroupDto;

    @ViewChild(LayoutSettingsComponent, { static: true })
	public layoutSettings: LayoutSettingsComponent;

	public get enableApply(): boolean {
		let validMapSettingsChanges = (!this.form.pristine && this.form.valid);
		let validLayoutSettingsChanges = this.layoutSettings.enableApply;
		return (validMapSettingsChanges || validLayoutSettingsChanges);
	}

	public form: UntypedFormGroup;

	public showMap: UntypedFormControl;
	public drawLinkLabels: UntypedFormControl;
	public includePhysicalLinks: UntypedFormControl;
	public includeAssociatedLinks: UntypedFormControl;
	public showChildGroups: UntypedFormControl;
	public showChildDevices: UntypedFormControl;

	public associatedLinksOptions: SelectItem[];

	constructor(private fb: UntypedFormBuilder) {
		super();

		this.target = null;

		this.associatedLinksOptions = [
			{ label: "Virtual", value: "virtual" },
			{ label: "Wireless", value: "wireless" },
			{ label: "IP Phone", value: "ip-phone" },
		];

		this.buildForm();
	}

	protected buildForm(): void {

		let showMap = false;
		let drawLinkLabels = false;
		let includePhysicalLinks = false;
		let showChildGroups = false;
		let showChildDevices = false;
		let includeAssociatedLinks = [];

		if (this.target) {
			let layoutSettings = this.target.DeviceGroup.Map.LayoutSettings;

			showMap = this.target.DeviceGroup.ShowMap;
			drawLinkLabels = layoutSettings.ShowLinkLabels;
			includePhysicalLinks = layoutSettings.ShowLayer2Links;
			showChildGroups = this.target.DeviceGroup.ShowChildGroups;
			showChildDevices = this.target.DeviceGroup.ShowChildDevices;	

			if (layoutSettings.ShowVirtualLinks)
				includeAssociatedLinks.push("virtual");
			if (layoutSettings.ShowWirelessLinks)
				includeAssociatedLinks.push("wireless");
			if (layoutSettings.ShowIpPhoneLinks)
				includeAssociatedLinks.push("ip-phone");
		}

		this.showMap = new UntypedFormControl(showMap);
		this.drawLinkLabels = new UntypedFormControl(drawLinkLabels);
		this.includePhysicalLinks = new UntypedFormControl(includePhysicalLinks);
		this.includeAssociatedLinks = new UntypedFormControl(includeAssociatedLinks);
		this.showChildGroups = new UntypedFormControl(showChildGroups);
		this.showChildDevices = new UntypedFormControl(showChildDevices);

		this.form = this.fb.group({
			showMap: this.showMap,
			drawLinkLabels: this.drawLinkLabels,
			includePhysicalLinks: this.includePhysicalLinks,
			includeAssociatedLinks: this.includeAssociatedLinks,
			showChildGroups: this.showChildGroups,
			showChildDevices: this.showChildDevices,
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["target"]) {
		}

		this.buildForm();
	}


	public get tempChanges(): boolean {
		return this.form.dirty || this.layoutSettings.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.form.valid && this.layoutSettings.tempChangesValid;
	}

	public discardTempChanges(): void {
		this.buildForm();
		this.layoutSettings.discardTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return ["Map Settings"];
	}

	public applyTempChanges(): void {
		if (this.target) {
			this.layoutSettings.applyTempChanges();

			this.getChanges();
			this.buildForm();
		}
	}

	public onShowChildGroupsChange() {
		if (!this.showChildGroups.value) {
			// If showChildGroups is unchecked, disable and set showChildDevices to false
			this.showChildDevices.disable();
			this.showChildDevices.setValue(false);
		} else {
			// If showChildGroups is checked, enable showChildDevices
			this.showChildDevices.enable();
		}
	}

	private getChanges(): void {
		let deviceGroup = this.target.DeviceGroup;
		let layoutSettings = this.target.DeviceGroup.Map.LayoutSettings;

		deviceGroup.ShowMap = this.showMap.value;
		layoutSettings.ShowLinkLabels = this.drawLinkLabels.value;
		layoutSettings.ShowLayer2Links = this.includePhysicalLinks.value;
		let assocs: string[] = this.includeAssociatedLinks.value;
		deviceGroup.ShowChildGroups = this.showChildGroups.value;
		deviceGroup.ShowChildDevices = this.showChildDevices.value;
		layoutSettings.ShowVirtualLinks = this.contains(assocs, "virtual");
		layoutSettings.ShowWirelessLinks = this.contains(assocs, "wireless");
		layoutSettings.ShowIpPhoneLinks = this.contains(assocs, "ip-phone");
	}

	private contains(arr: string[], str: string): boolean {
		return (arr.indexOf(str) >= 0);
	}

}
